import * as React from 'react';
export const errorSvg = React.forwardRef(function errorSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#D8DEE4',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'm19.076 8.131 6.147 11.177a3.75 3.75 0 0 1 .465 1.807v.823a3.75 3.75 0 0 1-3.75 3.75H10.063a3.75 3.75 0 0 1-3.75-3.75v-.823c0-.632.16-1.253.464-1.807L12.924 8.13a3.51 3.51 0 0 1 6.152 0Zm2.861 15.681H10.063a1.875 1.875 0 0 1-1.874-1.875v-.822c0-.316.08-.627.232-.904l6.147-11.176a1.636 1.636 0 0 1 2.866 0l6.147 11.176c.153.277.233.588.233.904v.823c0 1.035-.84 1.875-1.875 1.875Z',
      fill: '#474E5A',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M17.563 20.375c0 .862-.701 1.563-1.563 1.563a1.564 1.564 0 0 1-1.563-1.563 1.564 1.564 0 0 1 3.126 0Zm-2.813-7.502c-.036-.678.57-1.248 1.25-1.248s1.286.57 1.25 1.248l-.263 3.753a.988.988 0 0 1-1.974 0l-.263-3.753Z',
      fill: '#474E5A',
    }),
  );
});
errorSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var error = {
  category: 'brand',
  colorable: false,
  name: 'error',
  svg: errorSvg,
};
